export const TDOE_DATA_DASHBOARD_ORGANIZATION_ID =
  "22a78f5f-a360-49c7-a89c-c939fc137c15";

export const TDOE_CHART_TYPES = {
  PIE: "pie",
  BAR: "bar",
  STACKED_BAR: "stackedBar",
  CLUSTER_BAR: "clusterBar",
};

export const TDOE_GRADE_LEVELS = {
  KINDERGARTEN: "Kindergarten",
  PRE_KINDERGARTEN: "Pre-Kindergarten",
  FIRST_GRADE: "First Grade",
  SECOND_GRADE: "Second Grade",
};

export const TDOE_GROUP_BY = {
  DISTRICT: "District",
  GRADE_LEVEL: "GradeLevel",
};

export const tdoeReportsRegistry = [
  {
    id: "culture-of-learning-summary-rating",
    title: "Culture of Learning: Summary Rating",
    chartType: TDOE_CHART_TYPES.PIE,
    questionSurveyTemplateFieldId:
      "FEA37C3E-9E6D-4E7C-BCC5-A60895DAB20D",
    defaultGroupBy: null,
    hasDefinition: true,
  },
  {
    id: "culture-of-learning-summary-rating-by-campus",
    title:
      "Culture of Learning: Summary Rating by Campus — Percentage of Teachers Rating Yes",
    chartType: TDOE_CHART_TYPES.BAR,
    questionSurveyTemplateFieldId:
      "FEA37C3E-9E6D-4E7C-BCC5-A60895DAB20D",
    defaultGroupBy: TDOE_GROUP_BY.DISTRICT,
    hasDefinition: true,
  },
  {
    id: "culture-of-learning-summary-rating-by-grade-level",
    title:
      "Culture of Learning: Summary Rating by Grade Level — Percentage of Teachers Rating Yes",
    chartType: TDOE_CHART_TYPES.BAR,
    questionSurveyTemplateFieldId:
      "FEA37C3E-9E6D-4E7C-BCC5-A60895DAB20D",
    defaultGroupBy: TDOE_GROUP_BY.GRADE_LEVEL,
    hasDefinition: true,
  },
  {
    id: "core-action-1-summary-rating",
    title: "Core Action 1: Summary Rating",
    chartType: TDOE_CHART_TYPES.PIE,
    questionSurveyTemplateFieldId:
      "8D114412-2EA8-40A3-90C4-A06BD00FA0E6",
    defaultGroupBy: null,
    hasDefinition: true,
  },
  {
    id: "core-action-1-summary-rating-by-campus",
    title:
      "Core Action 1: Summary Rating by Campus — Percentage of Teachers Rating Yes",
    chartType: TDOE_CHART_TYPES.BAR,
    questionSurveyTemplateFieldId:
      "8D114412-2EA8-40A3-90C4-A06BD00FA0E6",
    defaultGroupBy: TDOE_GROUP_BY.DISTRICT,
    hasDefinition: true,
  },
  {
    id: "core-action-1-summary-rating-by-grade-level",
    title:
      "Core Action 1: Summary Rating by Grade Level — Percentage of Teachers Rating Yes",
    chartType: TDOE_CHART_TYPES.BAR,
    questionSurveyTemplateFieldId:
      "8D114412-2EA8-40A3-90C4-A06BD00FA0E6",
    defaultGroupBy: TDOE_GROUP_BY.GRADE_LEVEL,
    hasDefinition: true,
  },
  {
    id: "core-action-2-summary-rating",
    title: "Core Action 2: Summary Rating",
    chartType: TDOE_CHART_TYPES.PIE,
    questionSurveyTemplateFieldId:
      "35ACB250-8DC6-44FD-8D49-E3D7850585DA",
    defaultGroupBy: null,
    hasDefinition: true,
  },
  {
    id: "core-action-2-summary-rating-by-campus",
    title:
      "Core Action 2: Summary Rating by Campus — Percentage of Teachers Rating at Each Level",
    chartType: TDOE_CHART_TYPES.STACKED_BAR,
    questionSurveyTemplateFieldId:
      "35ACB250-8DC6-44FD-8D49-E3D7850585DA",
    defaultGroupBy: TDOE_GROUP_BY.DISTRICT,
    hasDefinition: true,
  },
  {
    id: "core-action-2-summary-rating-by-grade-level",
    title:
      "Core Action 2: Summary Rating by Grade Level — Percentage of Teachers at Each Level",
    chartType: TDOE_CHART_TYPES.STACKED_BAR,
    questionSurveyTemplateFieldId:
      "35ACB250-8DC6-44FD-8D49-E3D7850585DA",
    defaultGroupBy: TDOE_GROUP_BY.GRADE_LEVEL,
    hasDefinition: true,
  },
  {
    id: "core-action-3-summary-rating",
    title: "Core Action 3: Summary Rating",
    chartType: TDOE_CHART_TYPES.PIE,
    questionSurveyTemplateFieldId:
      "4AECCED5-80BA-4131-82B1-435CCAEBB30B",
    defaultGroupBy: null,
    hasDefinition: true,
  },
  {
    id: "core-action-3-summary-by-campus",
    title:
      "Core Action 3: Summary by Campus — Percentage of Teachers at Each Level",
    chartType: TDOE_CHART_TYPES.STACKED_BAR,
    questionSurveyTemplateFieldId:
      "4AECCED5-80BA-4131-82B1-435CCAEBB30B",
    defaultGroupBy: TDOE_GROUP_BY.DISTRICT,
    hasDefinition: true,
  },
  {
    id: "core-action-3-summary-rating-by-grade-level",
    title:
      "Core Action 3: Summary Rating by Grade Level — Percentage of Teachers at Each Level",
    chartType: TDOE_CHART_TYPES.STACKED_BAR,
    questionSurveyTemplateFieldId:
      "4AECCED5-80BA-4131-82B1-435CCAEBB30B",
    defaultGroupBy: TDOE_GROUP_BY.GRADE_LEVEL,
    hasDefinition: true,
  },
  {
    id: "core-action-2a-state-summary",
    title: "Core Action 2.A — State Summary",
    chartType: TDOE_CHART_TYPES.PIE,
    questionSurveyTemplateFieldId:
      "1B8F7296-DAFF-44C0-899A-DB8FB6C1585B",
    defaultGroupBy: null,
    hasDefinition: true,
  },
  {
    id: "core-action-2a-grade-level-summary",
    title: "Core Action 2.A — Grade Level Summary",
    chartType: TDOE_CHART_TYPES.STACKED_BAR,
    questionSurveyTemplateFieldId:
      "1B8F7296-DAFF-44C0-899A-DB8FB6C1585B",
    defaultGroupBy: TDOE_GROUP_BY.GRADE_LEVEL,
    hasDefinition: true,
  },
  {
    id: "core-action-2a-district-campus-summary",
    title: "Core Action 2.A — District/Campus Summary",
    chartType: TDOE_CHART_TYPES.STACKED_BAR,
    questionSurveyTemplateFieldId:
      "1B8F7296-DAFF-44C0-899A-DB8FB6C1585B",
    defaultGroupBy: TDOE_GROUP_BY.DISTRICT,
    hasDefinition: true,
  },
  {
    id: "core-action-2b-state-summary",
    title: "Core Action 2.B — State Summary",
    chartType: TDOE_CHART_TYPES.PIE,
    questionSurveyTemplateFieldId:
      "4B4DC0E8-57EE-441F-8D76-9A9C2324E3F6",
    defaultGroupBy: null,
    hasDefinition: true,
  },
  {
    id: "core-action-2b-grade-level-summary",
    title: "Core Action 2.B — Grade Level Summary",
    chartType: TDOE_CHART_TYPES.STACKED_BAR,
    questionSurveyTemplateFieldId:
      "4B4DC0E8-57EE-441F-8D76-9A9C2324E3F6",
    defaultGroupBy: TDOE_GROUP_BY.GRADE_LEVEL,
    hasDefinition: true,
  },
  {
    id: "core-action-2b-district-campus-summary",
    title: "Core Action 2.B — District/Campus Summary",
    chartType: TDOE_CHART_TYPES.STACKED_BAR,
    questionSurveyTemplateFieldId:
      "4B4DC0E8-57EE-441F-8D76-9A9C2324E3F6",
    defaultGroupBy: TDOE_GROUP_BY.DISTRICT,
    hasDefinition: true,
  },
  {
    id: "core-action-2c-state-summary",
    title: "Core Action 2.C — State Summary",
    chartType: TDOE_CHART_TYPES.PIE,
    questionSurveyTemplateFieldId:
      "66A933F2-351A-49AE-B952-EB8D52EB2159",
    defaultGroupBy: null,
    hasDefinition: true,
  },
  {
    id: "core-action-2c-grade-level-summary",
    title: "Core Action 2.C — Grade Level Summary",
    chartType: TDOE_CHART_TYPES.STACKED_BAR,
    questionSurveyTemplateFieldId:
      "66A933F2-351A-49AE-B952-EB8D52EB2159",
    defaultGroupBy: TDOE_GROUP_BY.GRADE_LEVEL,
    hasDefinition: true,
  },
  {
    id: "core-action-2c-district-campus-summary",
    title: "Core Action 2.C — District/Campus Summary",
    chartType: TDOE_CHART_TYPES.STACKED_BAR,
    questionSurveyTemplateFieldId:
      "66A933F2-351A-49AE-B952-EB8D52EB2159",
    defaultGroupBy: TDOE_GROUP_BY.DISTRICT,
    hasDefinition: true,
  },
  {
    id: "core-action-2d-state-summary",
    title: "Core Action 2.D — State Summary",
    chartType: TDOE_CHART_TYPES.PIE,
    questionSurveyTemplateFieldId:
      "B9421AD5-2DE4-4907-9DED-B2B8F2AED4B6",
    defaultGroupBy: null,
    hasDefinition: true,
  },
  {
    id: "core-action-2d-grade-level-summary",
    title: "Core Action 2.D — Grade Level Summary",
    chartType: TDOE_CHART_TYPES.STACKED_BAR,
    questionSurveyTemplateFieldId:
      "B9421AD5-2DE4-4907-9DED-B2B8F2AED4B6",
    defaultGroupBy: TDOE_GROUP_BY.GRADE_LEVEL,
    hasDefinition: true,
  },
  {
    id: "core-action-2d-district-campus-summary",
    title: "Core Action 2.D — District/Campus Summary",
    chartType: TDOE_CHART_TYPES.STACKED_BAR,
    questionSurveyTemplateFieldId:
      "B9421AD5-2DE4-4907-9DED-B2B8F2AED4B6",
    defaultGroupBy: TDOE_GROUP_BY.DISTRICT,
    hasDefinition: true,
  },
  {
    id: "core-action-2e-state-summary",
    title: "Core Action 2.E — State Summary",
    chartType: TDOE_CHART_TYPES.PIE,
    questionSurveyTemplateFieldId:
      "9D4C75A7-B3F1-45F3-9F49-E5B3241A06ED",
    defaultGroupBy: null,
    hasDefinition: true,
  },
  {
    id: "core-action-2e-grade-level-summary",
    title: "Core Action 2.E — Grade Level Summary",
    chartType: TDOE_CHART_TYPES.STACKED_BAR,
    questionSurveyTemplateFieldId:
      "9D4C75A7-B3F1-45F3-9F49-E5B3241A06ED",
    defaultGroupBy: TDOE_GROUP_BY.GRADE_LEVEL,
    hasDefinition: true,
  },
  {
    id: "core-action-2e-district-campus-summary",
    title: "Core Action 2.E — District/Campus Summary",
    chartType: TDOE_CHART_TYPES.STACKED_BAR,
    questionSurveyTemplateFieldId:
      "9D4C75A7-B3F1-45F3-9F49-E5B3241A06ED",
    defaultGroupBy: TDOE_GROUP_BY.DISTRICT,
    hasDefinition: true,
  },
  {
    id: "core-action-3a-state-summary",
    title: "Core Action 3.A — State Summary",
    chartType: TDOE_CHART_TYPES.PIE,
    questionSurveyTemplateFieldId:
      "9FF6F65C-D991-42A1-80B7-9E80F5A2E0C3",
    defaultGroupBy: null,
    hasDefinition: true,
  },
  {
    id: "core-action-3a-grade-level-summary",
    title: "Core Action 3.A — Grade Level Summary",
    chartType: TDOE_CHART_TYPES.STACKED_BAR,
    questionSurveyTemplateFieldId:
      "9FF6F65C-D991-42A1-80B7-9E80F5A2E0C3",
    defaultGroupBy: TDOE_GROUP_BY.GRADE_LEVEL,
    hasDefinition: true,
  },
  {
    id: "core-action-3a-campus-district-summary",
    title: "Core Action 3.A — Campus/District Summary",
    chartType: TDOE_CHART_TYPES.STACKED_BAR,
    questionSurveyTemplateFieldId:
      "9FF6F65C-D991-42A1-80B7-9E80F5A2E0C3",
    defaultGroupBy: TDOE_GROUP_BY.DISTRICT,
    hasDefinition: true,
  },
  {
    id: "core-action-3b-state-summary",
    title: "Core Action 3.B — State Summary",
    chartType: TDOE_CHART_TYPES.PIE,
    questionSurveyTemplateFieldId:
      "8ECDB6FA-5A81-4207-8EF4-126AA737A5B9",
    defaultGroupBy: null,
    hasDefinition: true,
  },
  {
    id: "core-action-3b-district-campus-summary",
    title: "Core Action 3.B — District/Campus Summary",
    chartType: TDOE_CHART_TYPES.STACKED_BAR,
    questionSurveyTemplateFieldId:
      "8ECDB6FA-5A81-4207-8EF4-126AA737A5B9",
    defaultGroupBy: TDOE_GROUP_BY.GRADE_LEVEL,
    hasDefinition: true,
  },
  {
    id: "core-action-3b-campus-district-summary",
    title: "Core Action 3.B — Campus/District Summary",
    chartType: TDOE_CHART_TYPES.STACKED_BAR,
    questionSurveyTemplateFieldId:
      "8ECDB6FA-5A81-4207-8EF4-126AA737A5B9",
    defaultGroupBy: TDOE_GROUP_BY.DISTRICT,
    hasDefinition: true,
  },
  {
    id: "core-action-3c-state-summary",
    title: "Core Action 3.C — State Summary",
    chartType: TDOE_CHART_TYPES.PIE,
    questionSurveyTemplateFieldId:
      "F4DCD368-3395-42F1-9963-7E7DFB0B1232",
    defaultGroupBy: null,
    hasDefinition: true,
  },
  {
    id: "core-action-3c-grade-level-summary",
    title: "Core Action 3.C — Grade Level Summary",
    chartType: TDOE_CHART_TYPES.STACKED_BAR,
    questionSurveyTemplateFieldId:
      "F4DCD368-3395-42F1-9963-7E7DFB0B1232",
    defaultGroupBy: TDOE_GROUP_BY.GRADE_LEVEL,
    hasDefinition: true,
  },
  {
    id: "core-action-3c-district-campus-summary",
    title: "Core Action 3.C — District/Campus Summary",
    chartType: TDOE_CHART_TYPES.STACKED_BAR,
    questionSurveyTemplateFieldId:
      "F4DCD368-3395-42F1-9963-7E7DFB0B1232",
    defaultGroupBy: TDOE_GROUP_BY.DISTRICT,
    hasDefinition: true,
  },
  {
    id: "kindergarten-core-action-2-state-overview",
    title: "Kindergarten Core Action 2 State Overview",
    chartType: TDOE_CHART_TYPES.CLUSTER_BAR,
    questionSurveyTemplateFieldId: null,
    defaultGroupBy: null,
    gradeLevel: TDOE_GRADE_LEVELS.KINDERGARTEN,
    coreAction: "2",
    hasDefinition: true,
  },
  {
    id: "pre-kindergarten-core-action-2-state-overview",
    title: "Pre-Kindergarten Core Action 2 State Overview",
    chartType: TDOE_CHART_TYPES.CLUSTER_BAR,
    questionSurveyTemplateFieldId: null,
    defaultGroupBy: null,
    gradeLevel: TDOE_GRADE_LEVELS.PRE_KINDERGARTEN,
    coreAction: "2",
    hasDefinition: true,
  },
  {
    id: "1st-grade-core-action-2-overview",
    title: "1st Grade Core Action 2 Overview",
    chartType: TDOE_CHART_TYPES.CLUSTER_BAR,
    questionSurveyTemplateFieldId: null,
    defaultGroupBy: null,
    gradeLevel: TDOE_GRADE_LEVELS.FIRST_GRADE,
    coreAction: "2",
    hasDefinition: true,
  },
  {
    id: "2nd-grade-core-action-2-overview",
    title: "2nd Grade Core Action 2 Overview",
    chartType: TDOE_CHART_TYPES.CLUSTER_BAR,
    questionSurveyTemplateFieldId: null,
    defaultGroupBy: null,
    gradeLevel: TDOE_GRADE_LEVELS.SECOND_GRADE,
    coreAction: "2",
    hasDefinition: true,
  },
  {
    id: "kindergarten-core-action-3-state-overview",
    title: "Kindergarten Core Action 3 State Overview",
    chartType: TDOE_CHART_TYPES.CLUSTER_BAR,
    questionSurveyTemplateFieldId: null,
    defaultGroupBy: null,
    gradeLevel: TDOE_GRADE_LEVELS.KINDERGARTEN,
    coreAction: "3",
    hasDefinition: true,
  },
  {
    id: "pre-k-core-action-3-state-overview",
    title: "Pre-K Core Action 3 State Overview",
    chartType: TDOE_CHART_TYPES.CLUSTER_BAR,
    questionSurveyTemplateFieldId: null,
    defaultGroupBy: null,
    gradeLevel: TDOE_GRADE_LEVELS.PRE_KINDERGARTEN,
    coreAction: "3",
    hasDefinition: true,
  },
  {
    id: "1st-grade-core-action-3-overview",
    title: "1st Grade Core Action 3 State Overview",
    chartType: TDOE_CHART_TYPES.CLUSTER_BAR,
    questionSurveyTemplateFieldId: null,
    defaultGroupBy: null,
    gradeLevel: TDOE_GRADE_LEVELS.FIRST_GRADE,
    coreAction: "3",
    hasDefinition: true,
  },
  {
    id: "2nd-grade-core-action-3-overview",
    title: "2nd Grade Core Action 3 State Overview",
    chartType: TDOE_CHART_TYPES.CLUSTER_BAR,
    questionSurveyTemplateFieldId: null,
    defaultGroupBy: null,
    gradeLevel: TDOE_GRADE_LEVELS.SECOND_GRADE,
    coreAction: "3",
    hasDefinition: true,
  },
];
